import React from 'react'
import img1 from '../../img/selab/selab3.jpeg'
const HomeContent2 = () => {
  return (
    <div>
<div>
  {/* Video Modal Start*/}
  <div className="modal fade" id="videoModal" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div className="modal-dialog" role="document">
      <div className="modal-content">
        <div className="modal-body">
          <button type="button" className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>        
          {/* 16:9 aspect ratio */}
          <div className="embed-responsive embed-responsive-16by9">
            <iframe className="embed-responsive-item" src id="video" allowscriptaccess="always" allow="autoplay" />
          </div>
        </div>
      </div>
    </div>
  </div> 
  {/* Video Modal End */}
  {/* About Start */}
  <div className="about">
    <div className="container">
      <div className="row align-items-center">
        <div className="col-lg-6">
          {/* <div className="about-img" data-parallax="scroll" data-image-src={img1} /> */}
          <img className="about-img" data-parallax="scroll"  src={img1}/>
        </div>
        <div className="col-lg-6">
          <div className="section-header">
            <p>Learn About Us</p>
            <h2>Worldwide non-profit charity organization</h2>
          </div>
          <div className="about-tab">
            <ul className="nav nav-pills nav-justified">
              <li className="nav-item">
                <a className="nav-link active" data-toggle="pill" href="#tab-content-1">About</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" data-toggle="pill" href="#tab-content-2">Mission</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" data-toggle="pill" href="#tab-content-3">Vision</a>
              </li>
            </ul>
            <div className="tab-content">
              <div id="tab-content-1" className="container tab-pane active">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vitae pellentesque turpis. Donec in hendrerit dui, vel blandit massa. Ut vestibulum suscipit cursus. Cras quis porta nulla, ut placerat risus. Aliquam nec magna eget velit luctus dictum. Phasellus et felis sed purus tristique dignissim. Morbi sit amet leo at purus accumsan pellentesque. Vivamus fermentum nisi vel dapibus blandit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              </div>
              <div id="tab-content-2" className="container tab-pane fade">
                Sed tincidunt, magna ut vehicula volutpat, turpis diam condimentum justo, posuere congue turpis massa in mi. Proin ornare at massa at fermentum. Nunc aliquet sed nisi iaculis ornare. Nam semper tortor eget est egestas, eu sagittis nunc sodales. Interdum et malesuada fames ac ante ipsum primis in faucibus. Praesent bibendum sapien sed purus molestie malesuada. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              </div>
              <div id="tab-content-3" className="container tab-pane fade">
                Aliquam dolor odio, mollis sed feugiat sit amet, feugiat ut sapien. Nunc eu dignissim lorem. Suspendisse at hendrerit enim. Interdum et malesuada fames ac ante ipsum primis in faucibus. Sed condimentum semper turpis vel facilisis. Nunc vel faucibus orci. Mauris ut mauris rhoncus, efficitur nisi at, venenatis quam. Praesent egestas pretium enim sit amet finibus. Curabitur at erat molestie, tincidunt lorem eget, consequat ligula.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* About End */}
</div>


    </div>
  )
}

export default HomeContent2